import React from "react"
import { ClientsBoundary } from "./boundary"
import CreateClient from "./views/CreateClient"
import EditClient from "./views/EditClient"
import ListClients from "./views/List"
import ViewClient from "./views/View"

export const VListClients: React.FC = (props) => {
  return (
    <ClientsBoundary>
      <ListClients {...props} />
    </ClientsBoundary>
  )
}

export const VEditClient: React.FC = (props) => {
  return (
    <ClientsBoundary>
      <EditClient {...props} />
    </ClientsBoundary>
  )
}

export const VCreateClient: React.FC = (props) => {
  return (
    <ClientsBoundary>
      <CreateClient {...props} />
    </ClientsBoundary>
  )
}

export const VViewClient: React.FC = (props) => {
  return (
    <ClientsBoundary>
      <ViewClient {...props} />
    </ClientsBoundary>
  )
}
